import { useState } from "react";

import { SearchIcon } from "../assets/Icons";
import { DropDownIcon } from "../icons/forms";
import {
  SearchProp,
  SelectProps,
  ButtonProps,
  InputProps,
  RadioGroupProps,
} from "./types";

export const Search = (prop: SearchProp) => {
  return (
    <div className="w-full min-w-72 relative">
      <input
        type="search"
        placeholder={prop.placeholder || ""}
        onChange={prop.onChange}
        className="w-full p-3 pl-10 rounded-3xl bg-navBG satoshi-base-normal-gray-400"
      />
      <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
        <SearchIcon />
      </div>
    </div>
  );
};

export const Select = (prop: SelectProps) => {
  return (
    <div className="relative">
      <select
        className={`w-full p-3 appearance-none satoshi-base-normal-gray-400 ${
          prop.type === "filter"
            ? "px-10 rounded-3xl bg-navBG min-w-36"
            : "bg-white border border-gray-400 rounded-lg"
        }`}
        onChange={prop.onChange}
      >
        {prop.options?.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </select>
      {prop.icon && (
        <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
          {prop.icon}
        </div>
      )}
      <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
        <DropDownIcon />
      </div>
    </div>
  );
};

export const GradientButton = ({
  content,
  onClick,
  type,
  disabled,
}: ButtonProps) => {
  return (
    <button
      type={type ? type : "button"}
      onClick={onClick}
      className="rounded-lg text-nowrap py-3 px-5 bg-gradient-to-r from-pry-500 to-pry-600 satoshi-base-bold-white"
      disabled={disabled}
    >
      {content}
    </button>
  );
};

export const OutlineButton = ({ content, onClick }: ButtonProps) => {
  return (
    <button
      onClick={onClick}
      className="row-3 h-fit items-center border border-gray-300 rounded-lg px-5 py-3 satoshi-base-bold-gray-900 text-nowrap"
    >
      {content}
    </button>
  );
};

export const Input = (prop: InputProps) => {
  const [inputValue, setInputValue] = useState("");
  return (
    <div className="relative w-full">
      <input
        type={prop.type || "text"}
        className="w-full p-3 rounded-lg border border-gray-400 placeholder:satoshi-base-normal-gray-400"
        placeholder={prop.placeholder || ""}
        onChange={(e) => {
          setInputValue(e.target.value);
          prop.onChange?.(e);
        }}
      />
      {prop.icon && (
        <div
          className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
          onClick={(e) => prop.icon?.onClick && prop?.icon?.onClick(inputValue)}
        >
          {prop.icon.icon}
        </div>
      )}
    </div>
  );
};

export const Toggle = ({ text }: { text: string }) => {
  const [isOn, setIsOn] = useState(false);
  return (
    <div className="row-4 items-center">
      <span className="text-nowrap inter-base-normal-gray-600">{text}</span>
      <button
        onClick={() => setIsOn(!isOn)}
        className={`w-9 h-5 flex items-center rounded-xl p-0.5 transition ${
          isOn ? "bg-pry-500" : "bg-border-dark"
        }`}
      >
        <div
          className={`w-4 h-4 bg-white rounded-full shadow-md transform transition ${
            isOn ? "translate-x-4" : "translate-x-0"
          }`}
        />
      </button>
    </div>
  );
};

export const RadioGroup = (prop: RadioGroupProps) => {
  const [selected, setSelected] = useState("");

  const handleChange = (value: string) => {
    setSelected(value);
    prop.onChange?.(value);
  };

  return (
    <div
      className={`flex gap-4 ${prop.dir === "row" ? "flex-row" : "flex-col"}`}
    >
      {prop.options.map((option) => (
        <label
          key={option.value}
          className="flex items-center row-2 cursor-pointer"
        >
          <input
            type="radio"
            name={prop.name}
            value={option.value}
            checked={selected === option.value}
            onChange={() => handleChange(option.value)}
            className="form-radio size-4 text-blue-600"
          />
          <span className="satoshi-sm-medium-gray-700 text-nowrap">
            {option.label}
          </span>
        </label>
      ))}
    </div>
  );
};
